import { useGeneralSettings } from "@/packages/context/GeneralSettingContext";
import { useCurrency } from "@/packages/context/CurrencyContext";

export const useFreeShippingThreshold = () => {
  const { shipping } = useGeneralSettings();
  const { id: currencyId } = useCurrency();

  if (
    !shipping ||
    shipping.shipping_settings !== 2 ||
    !shipping.countryShipping ||
    !currencyId
  ) {
    return null;
  }

  // Filter ranges for the selected currency
  const currencyRanges = shipping.countryShipping.filter(
    (item) => Number(item.currencyId) === Number(currencyId)
  );

  if (currencyRanges.length === 0) return null;

  // Group by countryId and find the first countryId
  const countryIds = Array.from(
    new Set(currencyRanges.map((item) => item.countryId))
  );
  if (countryIds.length === 0) return null;
  const firstCountryId = countryIds[0];

  // Get all ranges for that first country
  const firstCountryRanges = currencyRanges.filter(
    (item) => item.countryId === firstCountryId
  );

  // The free shipping threshold is the maximum maximumAmount of that country's ranges
  const maxAmounts = firstCountryRanges.map((item) => item.maximumAmount);
  if (maxAmounts.length === 0) return null;

  return Math.max(...maxAmounts);
};
